<template>
  <div class="main-body">
    <main-header></main-header>
    <main-content>
    </main-content>
    <main-footer ref="footer"></main-footer>
  </div>
</template>

<script>
import MainHeader from "./header";
import MainContent from "./main";
import MainFooter from "./footer";

export default {
  name: "main-index",
  components: {
    MainHeader,
    MainContent,
    MainFooter
  },
  computed: {},
  data() {
    return {

    };
  },
  beforeCreate() {
    // 验证token是否过期
    // const token = window.sessionStorage.getItem("Authorization");
    // if (!token) {
    //   window.location.href = 'login.html'
    // }
  },
  methods: {

  }
};
</script>
